<template>
  <table>
    <tr>
      <td></td>
      <td>系数</td>
    </tr>
    <tr 
      v-for="(item,index) of arr_days" 
      :key="index"
      :class="{'on':item.status_on}"
      >
      <td>Day {{item.on_day}}</td>
      <td>
        <span :class="['num-bar',{'on':item.status_on}]" :style="`width: ${item.ui_length};`">
          <span>
            {{item.num}}
          </span>
        </span>
      </td>
    </tr>
  </table>
</template>

<script>

export default {
  name: 'daysChart',
  components: {},
  props: [],
  data() {
    return {
      cfg_start_num: 10000,
      cfg_rate: 0.95,

      arr_days: [],
    }
  },
  computed: {},
  watch: {},
  methods: {
    run(){
      let v = this
      
      let max_length = 300

      for(let i = 1; i<=5; i++){
        
        let num = parseFloat((v.cfg_start_num * Math.pow(v.cfg_rate, i-1)).toFixed(0))

        let item = {
          on_day: i,
          num: num,
          ui_length: parseInt(max_length*( Math.pow(num/v.cfg_start_num,2) )) + 'px',
          status_on: false,
        }

        if(i==2){
          item.status_on = true
        }

        v.arr_days.push(item)
      }
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  table{
    $c: #8A49DA;

    color: $c;

    .num-bar{
      display: inline-block;
      border-radius: 4px;
      text-align: right;
      padding: 0 10px;
      background: $c;
      height: 26px;
      line-height: 26px;
      color: #fff;
      font-size: 16px;
    }

    tr{
      opacity: 0.7;
      &.on{
        opacity: 1;
        font-weight: bold;
      }
    }
    td{
      padding-bottom: 5px;
      &:first-child{
        padding-right: 10px;
        font-weight: bold;
      }
    }
  }
</style>